import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, InstagramIcon } from 'lucide-react';
export function InstagramVideos() {
  const videos = [{
    img: 'https://cdn.magicpatterns.com/uploads/bmJUp6HFtTtQiY35uSMDU6/WhatsApp_Image_2026-03-27_at_7.57.48_PM.jpg',
    title: 'Stitch Braid Magic'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/bs5n9Zm32XefA6AMuJFbwS/WhatsApp_Image_2026-03-27_at_7.53.20_PM_(1).jpg',
    title: 'Senegalese Transformation'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/xw8DuN4qsKH2eRTToQZS5E/WhatsApp_Image_2026-03-27_at_7.53.57_PM.jpg',
    title: 'Perfect Mid-Back'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/nSTHv4x5S1XDhv6UarqhMU/WhatsApp_Image_2026-03-27_at_7.53.45_PM.jpg',
    title: 'Classic Box Braids'
  }];
  return <section className="py-12 bg-near-black text-cream overflow-hidden" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-gold/10 border border-brand-gold/20 mb-4" data-id="element-213">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-gold" data-id="element-214">
              Latest Transformations
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-5xl mb-4" data-id="element-215">
            See Our Work In Action
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-216">
          {videos.map((video, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-warm-brown/20 border border-cream/10 group" data-id="element-217">
              <img src={video.img} alt={video.title} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700" data-id="element-218" />
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center z-10" data-id="element-219">
                <div className="w-12 h-12 rounded-full bg-brand-gold/90 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg" data-id="element-220">
                  <PlayIcon className="w-6 h-6 text-near-black fill-near-black" data-id="element-221" />
                </div>
                <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="text-[10px] font-body text-cream uppercase tracking-widest bg-near-black/60 px-3 py-1 rounded-full backdrop-blur-sm" data-id="element-222">
                  Watch Video
                </a>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-near-black/80 via-transparent to-transparent opacity-60" data-id="element-223" />
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-224">
          <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-cream text-near-black font-bold uppercase tracking-widest text-xs hover:bg-brand-gold transition-colors" data-id="element-225">
            <InstagramIcon className="w-4 h-4" data-id="element-226" />
            Follow @roziiepse
          </a>
        </div>
      </div>
    </section>;
}